<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import gameControllerImg from '../../../assets/imgs/game-controller.png'
import Button from '../../General/Button.vue';
import { TEXT } from '../../../configs/text';
import { useClassStore, useSessionStore, useSignalRStore } from '../../../stores';
import { Session } from '../../../types/session';
import Modal from '../../General/Modal.vue';
import Iframe from '../../General/Iframe.vue';
import { computed, ref } from 'vue';
import { ClassStatus } from '../../../types/class';

const classStore = useClassStore()
const sessionStore = useSessionStore()
const signalr = useSignalRStore()
const modalShow = ref<boolean>(false)

const practiceUrl = computed<string | null>(() => sessionStore.practiceUrl[sessionStore.currentSession as Session.practice | Session.practice2])

function handlePracticeStart() {
    signalr.startPractice()
}

const { t } = useI18n()
</script>

<template>
    <div class="p-3 h-full flex flex-col items-center justify-evenly gap-2 overflow-auto">
        <img :src="gameControllerImg" class="max-w-88 mt-auto cursor-pointer" @click="modalShow = true" />

        <Button
            v-if="!sessionStore.practiceQuizState?.[sessionStore.currentSession as Session.practice | Session.practice2]"
            color="warning" class="mb-auto" @click="handlePracticeStart"
            :class="{ 'opacity-50': classStore?.selectedClassDetails?.state === ClassStatus.not_started }"
            :disabled="classStore?.selectedClassDetails?.state === ClassStatus.not_started">
            {{ t(TEXT.start_practice) }}
        </Button>
        <div v-else class="mb-auto">{{ t(TEXT.practice_in_progress) }}</div>

        <Modal v-model="modalShow" size="full" :full-height="true">
            <Iframe v-if="practiceUrl" :src="practiceUrl" orientation="full" />
        </Modal>
    </div>
</template>